import React from "react";
import { Message } from "semantic-ui-react";
import { useAuth } from "../../../hooks";
import { canCharge } from "../../../utils/constants";

// Pantallas de la Caja: solo para quien puede cobrar (Admin, Súper Usuario o
// Estándar con "Puede cobrar"). El menú ya las oculta y el backend lo exige;
// esto cubre a quien llegue escribiendo la dirección.
export function withCharge(Component) {
  return function RequireCharge(props) {
    const { auth } = useAuth();
    if (!canCharge(auth?.me)) {
      return (
        <Message warning>
          <Message.Header>Esta pantalla es de la Caja</Message.Header>
          <p>Pídele al administrador el permiso "Puede cobrar (caja)" si te toca cobrar.</p>
        </Message>
      );
    }
    return <Component {...props} />;
  };
}

// Reportes, Carta y Configuración: solo Admin/Súper Usuario (is_staff). Un
// Estándar (mozo, cajero) atiende y cobra, no administra.
export function withAdmin(Component) {
  return function RequireAdmin(props) {
    const { auth } = useAuth();
    if (!auth?.me?.is_staff) {
      return (
        <Message warning>
          <Message.Header>Esta pantalla es del administrador</Message.Header>
          <p>Tu usuario puede atender pedidos; para esto pídele ayuda al administrador.</p>
        </Message>
      );
    }
    return <Component {...props} />;
  };
}
